import { computed } from '@ember/object';
import CatalogObjectAdapter from '@square/dashboard-items-data/adapters/connect/catalog-object';
export const SUBSCRIPTION_ITEMIZATION_API_VERSION = '2023-06-08';
export default CatalogObjectAdapter.extend({
  headers: computed(function () {
    return {
      'Square-Version': SUBSCRIPTION_ITEMIZATION_API_VERSION
    };
  })
});